<template>
  <div class="realisation" id="realisation">
    <DirectionArrows :position="$props.position" :count="$props.count" :sidebar="$props.sidebar"/>

    <HelloWorld msg="Réalisations"/>
  </div>
</template>
<script>
  // @ is an alias to /src
  import HelloWorld from '@/components/HelloWorld.vue'
  import DirectionArrows from '@/components/ArrowsDirection.vue'

  export default {
    name: 'Realisation',
    props:['position','sidebar','count'],
    components: {
      HelloWorld,
      DirectionArrows
    }
  }
</script>

<style>
    #realisation{
        height: 80%;
        width: 40%;
        order:3;
      transition: .3s;

    }
</style>
